import {BaseHttpError} from './BaseHttpError'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../response/ErrorResponseBody'
import {HttpStatusCode} from '../../Constants'

export class HttpCritical extends BaseHttpError {

    constructor(status: HttpStatusCode, readonly responseBody: Nullable<ErrorResponseBody>) {
        super('HttpCritical', status, responseBody)
    }
}
